import { trapFocus, removeTrapFocus } from './trap-focus';

export default class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification-dialog');
    this.header = document.querySelector('#header');
    this.overlay = this.querySelector('#cart-notification-overlay');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.querySelectorAll('[data-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this)),
    );
  }

  open() {
    if (this.header) this.scrollToHeader();
    window.scrollLock();

    this.notification.setAttribute('open', 'true');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    (this.querySelector('[data-close]') as HTMLButtonElement)?.focus();
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClick);

    window.scrollUnlock();
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.getCartItemKey(parsedState);
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector,
      );
    });

    this.open();
  }

  scrollToHeader() {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }

  getCartItemKey(parsedState) {
    const items = parsedState?.items;

    if (!items || !Array.isArray(items) || items.length === 0) {
      this.cartItemKey = parsedState.key;
      return;
    }

    const regularItems = items.filter((item) => !item.properties?.['_Product ID']);

    if (regularItems.length === 0) {
      this.cartItemKey = items[0]?.key || null;
      return;
    }

    this.cartItemKey = regularItems[0].key;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: this.cartItemKey ? `[id="cart-notification-product-${this.cartItemKey}"]` : '.shopify-section',
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('#CartDrawer')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
